import { Component, OnInit, Inject, Optional, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProfileService } from '../../../../services/profile.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NbToastrService, NbGlobalPosition, NbGlobalPhysicalPosition, NbComponentStatus } from '@nebular/theme';
import { SignupService } from '../../../../services/signup.service';
import { patterns } from '../../../../../assets/patterns';

@Component({
  selector: 'add-edit-hierarchy',
  templateUrl: './add-edit-hierarchy.component.html',
  styleUrls: ['./add-edit-hierarchy.component.scss']
})
export class AddEditHierarchyComponent implements OnInit {
  operationType: String;
  hierarchyLevel: String;
  formUserHierarchy: UntypedFormGroup;
  preSignUpSTDetails: any;
  showAddForm: boolean = false;
  hierarchy: String;
  regionData: any = [];
  divisionData: any = [];
  regionId = null;
  loading: boolean = false;
  position: NbGlobalPosition = NbGlobalPhysicalPosition.TOP_RIGHT;
  statusSuccess: 'success';
  statusFailure: 'warning';
  destroyByClick = true;
  duration = 5000;
  hasIcon = true;
  preventDuplicates = false;
  onHierarchyUpdate = new EventEmitter();
  isBubbleCall: boolean = false;

  constructor(public dialogRef: MatDialogRef<AddEditHierarchyComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private profileService: ProfileService,
    private formBuilder: UntypedFormBuilder,
    private toastrService: NbToastrService,
    private signupService: SignupService) { }

  ngOnInit() {
    this.signupService.getStateType().subscribe((data: any) => {
      this.preSignUpSTDetails = data;
    });

    if (this.data.isBubbleCall == 1) {
      this.isBubbleCall = true;
    } else {
      this.data.hierarchyData.forEach(element => {
        if (element.hierarchy === "Region") {
          this.regionData.push(element)
        }

        if (element.hierarchy === "Division") {
          this.divisionData.push(element)
        }
      });
    }

    this.formUserHierarchy = this.formBuilder.group({
      UserHierarchyLevel: ['', Validators.required],
      UserHierarchyName: ['', Validators.required],
      UserHierarchyRegion: [''],
      UserHierarchyDivision: [''],
      UserHierarchyId: ['', Validators.required],
      UserHierarchyAddress: [''],
      UserHierarchyCity: [''],
      UserHierarchyState: [''],
      UserHierarchyZip: ['', Validators.pattern(patterns.numberPattern)],
      UserHierarchyPhone: ['', Validators.pattern(patterns.mobNumPattern)],
      UserHierarchyDayPhone: ['', Validators.pattern(patterns.mobNumPattern)],
      UserHierarchyNightPhone: ['', Validators.pattern(patterns.mobNumPattern)],
      UserHierarchyResponsibleParty: ['']
    });

    if (this.data.userData == 0) {
      this.operationType = "Add";
      if (this.isBubbleCall == true) {
        this.setBubbleCallData();
      }
    } else {
      this.operationType = "Edit";
      let arrAddress = this.data.userData.address.split("-")
      this.formUserHierarchy.setValue({
        UserHierarchyLevel: this.data.userData.hierarchy,
        UserHierarchyName: this.data.userData.customerName,
        UserHierarchyRegion: 0,
        UserHierarchyDivision: 0,
        UserHierarchyId: this.data.userData.externalId,
        UserHierarchyAddress: arrAddress[0] == undefined ? "" : arrAddress[0],
        UserHierarchyCity: arrAddress[1] == undefined ? "" : arrAddress[1],
        UserHierarchyState: arrAddress[2] == undefined ? "" : arrAddress[2],
        UserHierarchyZip: arrAddress[3] == undefined ? "" : arrAddress[3],
        UserHierarchyPhone: this.data.userData.dayPhone,
        UserHierarchyDayPhone: this.data.userData.dayPhone,
        UserHierarchyNightPhone: this.data.userData.nightPhone,
        UserHierarchyResponsibleParty: this.data.userData.responsibleParty
      });
      this.showForm();
      this.formUserHierarchy.get("UserHierarchyLevel").disable();

      this.regionData.forEach(region => {
        if (region.customerKey == this.data.userData.subCustomerKey) {
          this.formUserHierarchy.get("UserHierarchyRegion").setValue(region);
          this.regionId = region.customerKey;
        }
      });

      this.divisionData.forEach(division => {
        if (division.customerKey == this.data.userData.divisionKey) {
          this.formUserHierarchy.get("UserHierarchyDivision").setValue(division);
          this.formUserHierarchy.get("UserHierarchyRegion").disable();
        }
      });

    }
  }

  setBubbleCallData() {
    let userHierarchy = this.data.hierarchyData.hierarchy;
    let strUserHierarchyLevel = "Region";
    if (userHierarchy == "Corporate") {
      strUserHierarchyLevel = "Region";
    } else if (userHierarchy == "Region") {
      strUserHierarchyLevel = "Division";
      this.regionData.push({
        customerKey: this.data.hierarchyData.customerKey,
        customerName: this.data.hierarchyData.customerName,
        subCustomerKey: this.data.hierarchyData.subCustomerKey,
        externalId: this.data.hierarchyData.externalId,
      });
      this.formUserHierarchy.get("UserHierarchyRegion").setValue(this.data.hierarchyData.customerKey);
    } else if (userHierarchy == "Division") {
      strUserHierarchyLevel = "Location";
      this.regionData.push({
        customerKey: this.data.hierarchyData.parentKey,
        customerName: this.data.hierarchyData.parentName,
        externalId: this.data.hierarchyData.parentExternalId,
      });
      this.divisionData.push({
        customerKey: this.data.hierarchyData.customerKey,
        customerName: this.data.hierarchyData.customerName,
        subCustomerKey: this.data.hierarchyData.subCustomerKey,
        externalId: this.data.hierarchyData.externalId,
      });
      this.formUserHierarchy.get("UserHierarchyRegion").setValue(this.data.hierarchyData.subCustomerKey);
      this.formUserHierarchy.get("UserHierarchyDivision").setValue(this.data.hierarchyData.customerKey);
    }
    this.formUserHierarchy.get("UserHierarchyLevel").setValue(strUserHierarchyLevel);
    this.formUserHierarchy.get("UserHierarchyLevel").disable();
    this.showForm();
  }
  closeDialog() {
    this.dialogRef.close();
  }

  showForm() {
    // if (this.formUserHierarchy.get("UserHierarchyLevel").valid) {
    this.showAddForm = true;
    this.hierarchy = this.formUserHierarchy.get("UserHierarchyLevel").value.toString();
    this.hierarchyLevel = this.hierarchy + " Id";

    if (this.hierarchy === "Location") {
      this.formUserHierarchy.get("UserHierarchyRegion").setValidators(Validators.required);
      this.formUserHierarchy.get("UserHierarchyRegion").updateValueAndValidity();
      this.formUserHierarchy.get("UserHierarchyDivision").setValidators(Validators.required);
      this.formUserHierarchy.get("UserHierarchyDivision").updateValueAndValidity();
    } else if (this.hierarchy === "Division") {
      this.formUserHierarchy.get("UserHierarchyRegion").setValidators(Validators.required);
      this.formUserHierarchy.get("UserHierarchyRegion").updateValueAndValidity();
      this.formUserHierarchy.get("UserHierarchyDivision").clearValidators();
      this.formUserHierarchy.get("UserHierarchyDivision").updateValueAndValidity();
    } else if (this.hierarchy === "Region") {
      this.formUserHierarchy.get("UserHierarchyRegion").clearValidators();
      this.formUserHierarchy.get("UserHierarchyRegion").updateValueAndValidity();
      this.formUserHierarchy.get("UserHierarchyDivision").clearValidators();
      this.formUserHierarchy.get("UserHierarchyDivision").updateValueAndValidity();
    }

    // }
  }

  showRegion() {
    let subCustomerKey = this.formUserHierarchy.get("UserHierarchyDivision").value;
    subCustomerKey = subCustomerKey.subCustomerKey;
    this.regionData.forEach(region => {
      if (region.customerKey == subCustomerKey) {
        this.formUserHierarchy.get("UserHierarchyRegion").setValue(region);
      }
    });
  }

  showDivision() {
    let region = this.formUserHierarchy.get("UserHierarchyRegion").value;
    this.regionId = region.customerKey;
  }

  addEditHierarchy() {
    let data = {
      "hierarchyName": this.formUserHierarchy.get("UserHierarchyName").value,
      "hierarchyLevel": this.formUserHierarchy.get("UserHierarchyLevel").value,
      "hierarchyRegionId": this.hierarchy === "Region" ? this.formUserHierarchy.get("UserHierarchyId").value : (this.formUserHierarchy.get("UserHierarchyRegion").value).externalId,
      "hierarchyDivisionId": this.hierarchy === "Division" ? this.formUserHierarchy.get("UserHierarchyId").value : this.formUserHierarchy.get("UserHierarchyDivision").value == "" ? 0 : (this.formUserHierarchy.get("UserHierarchyDivision").value).externalId,
      "hierarchyLocationId": this.hierarchy === "Location" ? this.formUserHierarchy.get("UserHierarchyId").value : 0,
      "hierarchyAddress": this.formUserHierarchy.get("UserHierarchyAddress").value,
      "hierarchyCity": this.formUserHierarchy.get("UserHierarchyCity").value,
      "hierarchyState": this.formUserHierarchy.get("UserHierarchyState").value,
      "hierarchyZipCode": this.formUserHierarchy.get("UserHierarchyZip").value,
      "hierarchyPhone": this.formUserHierarchy.get("UserHierarchyPhone").value,
      "hierarchyDayPhone": this.formUserHierarchy.get("UserHierarchyDayPhone").value,
      "hierarchyNightPhone": this.formUserHierarchy.get("UserHierarchyNightPhone").value,
      "hierarchyResponsibleParty": this.formUserHierarchy.get("UserHierarchyResponsibleParty").value
    }

    this.loading = true;
    this.profileService.createTempHierarchyTable(data).subscribe(resHierarchy => {
      let hierarchyDetails = {
        "tableName": "tempManualHierarchyUpload",
        "ERSCustomerKey": sessionStorage.getItem('legacyCustomerKeyId'),
        "ERSCompanyName": sessionStorage.getItem('companyName'),
        "FACustomerKey": sessionStorage.getItem('fleetCustomerId')
      }
      this.profileService.UserHierarchy(hierarchyDetails).subscribe(response => {
        let msg = "Hierarchy added successfully"
        this.showToast(this.statusSuccess, this.position, msg);
        this.loading = false;
        this.onHierarchyUpdate.emit();
        this.dialogRef.close();
      });
    });
  }

  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: this.destroyByClick,
      duration: this.duration,
      hasIcon: this.hasIcon,
      position: this.position,
      preventDuplicates: this.preventDuplicates,
    };
    this.toastrService.show(
      body,
      "",
      config);
  }

}
